import React from 'react';
import CheckBoxControl from '../component/CheckBoxControl';
import PopUp from '../component/Popup'

const style = {
  backgroundColor:"rgba(60, 60, 60, 0.59)",
}
export default class TopSection extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      isHidden: true
    }
  }

  componentDidMount(){
    window.addEventListener('keydown',this.handleKey);
  }
  componentWillUnmount(){
    document.removeEventListener('keydown',this.handleKey);
  }

  handleKey = (e)=>{
    switch(e.keyCode){
      case 27:
        this.setState({isHidden: true})
        break;
        default:
    }
  }
  

  handleClick = () =>{
    this.setState ({isHidden: !this.state.isHidden})
  }
  
  render(){

    return(
        <div style={style} className="controlDivStyle">
          <img alt="site logo" title="Pomodoro Study Timer" src="../../favicon.png"></img>
          <CheckBoxControl name="Rain" sound={"rain"}/>
            <button title="Help" onClick={this.handleClick} className="btnStyle passiveBtnColor"  alt="question mark" role="img">
              &#63;
            </button>
            {
              this.state.isHidden ? "" :
                <PopUp>
                  <button onClick={this.handleClick} className="close">&times;</button>
                  <h1>What is the Pomodoro Technique?</h1>
                  <p>
                  Created by  Francesco Cirillo, Pomorodo technique is a time management method used to divide tasks into small interval with short breaks in-between.
                  Pomodoro increases productivity by taking short breaks regularly.
                  </p>
                  <h1>How does the Pomodoro Study Timer work?</h1>
                  <ol>
                      <li>Work for 25 minutes.</li>
                      <li>After 25 minutes a bell will ring.</li>
                      <li>Take a 5 minutes break.</li>
                      <li>The whole process repeats.</li>

                  </ol>
                  <h1>Why you should use PomodoroStudyTimer?</h1>
                  <p>
                  Taking longer breaks, longer sleep and taking time out of office allows our mind to be more productive, boost job performance and of course, it’s good for our health. 
As well as that, taking regular breaks can help you to make better decisions, help spark creative ideas and find new solutions and the big advantage of taking breaks can help the memory retain information.
Not taking breaks regularly could cause fatigue, people lose focus and their eyes could be damaged.
                  </p>
                </PopUp>

            }
        </div>
    )
  }
}